import React from 'react';
import clsx from 'clsx';

export type PageWidth = 'narrow' | 'default' | 'wide' | 'fluid';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  width?: PageWidth;
}

const widthClasses: Record<PageWidth, string> = {
  narrow: 'max-w-3xl',
  default: 'max-w-4xl',
  wide: 'max-w-7xl',
  fluid: 'max-w-none',
};

export const PageContainer: React.FC<PageContainerProps> = ({ children, className, width = 'default' }) => {
  return (
    <div className={clsx('w-full mx-auto px-2 sm:px-4 py-4', widthClasses[width], className)}>
      {children}
    </div>
  );
};

export default PageContainer;
